import { createSelector } from 'reselect';
import moment from 'moment';
const getLoggedUser = state => state.account.user;
const getCleaningList = state => state.cleaning.data;
const getSelectedDate = state => state.occupancy.date;

export const getCleaningListToUser = createSelector(
  [getLoggedUser, getCleaningList],
  (loggedUser, cleaningList) =>
    cleaningList.filter(cleaning => cleaning.userId === loggedUser.userId)
);

export const getCleaningListForDate = createSelector(
  [getCleaningList, getSelectedDate],
  (cleaningList, date) =>
    cleaningList.filter(
      cleaning =>
        moment.utc(cleaning.from) <= date && moment.utc(cleaning.to) >= date
    )
);

export const getCleaningListToRoom = room =>
  createSelector([getCleaningListForDate], cleaninglist =>
    cleaninglist.filter(cleaning =>
      cleaning.rooms.find(r => r.roomId === room.roomId)
    )
  );

export const getCleaningListToUserForDate = createSelector(
  [getCleaningListToUser, getSelectedDate],
  (cleaningList, date) =>
    cleaningList.filter(
      cleaning =>
        moment.utc(cleaning.from) <= date && moment.utc(cleaning.to) >= date
    )
);



// WEBPACK FOOTER //
// ./src/cleaning/selectors.js